import { getApiInstance } from '../helpers';

const login = (tokenId: string, email: string) => {
  return getApiInstance(false)
    .post('/auth', { token: tokenId, email, minutes: 30 })
    .then((res) => {
      console.debug('/auth res', res);
      if (res.data && res.data.token) {
        return res.data.token;
      }
    });
};

const meInfo = (): Promise<{ userId: number; isAdmin: boolean }> => {
  return getApiInstance()
    .get('/me/info')
    .then((res) => {
      console.debug('/me/info res', res);
      // for testing set isAdmin to be 0
      // return { ...res.data, isAdmin: 0 };
      return res.data;
    });
};

export const userService = {
  login,
  meInfo,
};
